import PropTypes from 'prop-types';
import React from 'react';

import { bemGenerator } from '@prisjakt/ui-base';

import './index.scss';

const styles = bemGenerator('pj-campaign-banner', ['banner']);

const Banner = ({ banners, type, alt }) => {
  if (!banners || !banners.length > 0) {
    return null;
  }

  const banner = banners.find(b => b.type.toUpperCase() === type.toUpperCase());
  if (!banner) {
    return null;
  }

  const { imageUrl, url: targetUrl } = banner;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <img
      src={imageUrl}
      alt={alt}
      role="link" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
      className={styles.banner.withModifier({ link: targetUrl })}
      onClick={() => {
        if (targetUrl) {
          window.open(targetUrl);
        }
      }}
    />
  );
};

const { string, shape, arrayOf } = PropTypes;
Banner.propTypes = {
  type: string.isRequired,
  alt: string,
  banners: arrayOf(
    shape({
      type: string,
      url: string,
      imageUrl: string,
    })
  ).isRequired,
};

Banner.defaultProps = {
  alt: '',
};

export default Banner;
